<template>
  <div>
    <b-row class="mt-3">
      <b-col>
        <span class="float-right mt-2" v-if="helpLink || !hideHome">
          <span v-if="helpLink">
            <b-link :to="helpLink" target="_blank">
              <font-awesome-icon icon="question-circle" />
              Help
            </b-link>
            |
          </span>
          <b-link to="/">
            Home
          </b-link>
        </span>
        <h1>{{title}}</h1>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: [ 'title', 'helpLink', 'hideHome' ],
  watch: {
    // This would be called anytime the value of title changes
    // title(newValue, oldValue) {
    //   console.log('change from ' + oldValue + ' to ' + newValue);
    // }
  }
}
</script>